<template>
  <div class="content-wrapper">
    <h3>میزکار</h3>

    <div class="data-container">
      <div class="data-box">
        <p>تعداد داده های آموزشی: 800</p>
      </div>
      <div class="data-box">
        <p>تعداد گفتگو ها: 100</p>
      </div>
    </div>
    <div class="button-wrapper">
      <router-link :to="`/datasets/${widgetId}/manage`" class="data-manage-btn">
        مدیریت داده‌های آموزشی
      </router-link>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useRoute } from "vue-router";
export default {
  name: "DashboardView",
  components: {},

  setup() {
    const route = useRoute();
    const widgetId = ref(route.params.widgetId);

    return { widgetId };
  },
};
</script>

<style scoped>
.content-wrapper {
  padding: 20px;
}
.data-container {
  display: grid;
  grid-template-columns: repeat(2, 40%);
  grid-gap: 20px;
  justify-content: center;
  margin: 50px 0;
}

.data-box {
  background: linear-gradient(145deg, #ffffff, #f5f8ff);
  border-radius: 20px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  padding: 30px;
  text-align: center;
  font-size: 18px;
  color: #334155;
  font-weight: 500;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(8px);
}
.data-box p {
  text-align: right;
}
.data-manage-btn {
  background: linear-gradient(135deg, #4f46e5, #06b6d4);
  color: white;
  font-size: 18px;
  font-weight: 500;
  border: none;
  padding: 14px 28px;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
  transition: all 0.3s ease;
  margin-bottom: 40px;
  width: 40%;
  text-decoration: none;
}
.data-manage-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(79, 70, 229, 0.45);
  background: linear-gradient(135deg, #4338ca, #0891b2);
}
.button-wrapper{
    display: flex;
    justify-content: center; 
    align-items: center;     
}
</style>
